import { Injectable } from '@angular/core';

import {
	PermanentlyDeleteNodesFromTrashResponse,
	RestoreAllTrashResponse,
	RestoreTrashResponse,
	SendTrashResponse,
} from '@reach/interfaces/trash/trash.responses';

import { BaseApiService } from '~app-client/api/_internal';
import { ReachNodeId } from '~app-client/core/types';

@Injectable({ providedIn: 'root' })
export class TrashApiService extends BaseApiService {
	protected commonPath = ['trash'];

	public async moveToTrash(ids: ReachNodeId[]): Promise<SendTrashResponse> {
		const body = {
			nodeIds: ids || [],
		};
		return await this.http.post<SendTrashResponse>(this.url(), body);
	}

	public async restoreFromTrash(ids: ReachNodeId[]): Promise<RestoreTrashResponse> {
		const body = {
			nodeIds: ids || [],
		};
		return await this.http.post<RestoreTrashResponse>(this.url('restore'), body);
	}

	public async restoreAllFromTrash(): Promise<RestoreAllTrashResponse> {
		return await this.http.post<RestoreAllTrashResponse>(this.url('restore-all'));
	}

	public async permanentlyDeleteNodes(
		...ids: ReachNodeId[]
	): Promise<PermanentlyDeleteNodesFromTrashResponse> {
		const body = {
			nodeIds: ids || [],
		};
		return await this.http.post<PermanentlyDeleteNodesFromTrashResponse>(
			this.url('delete'),
			body
		);
	}

	public async emptyTrash(): Promise<void> {
		return await this.http.post<void>(this.url('empty'));
	}
}
